/**
 * Shared field grid
 *
 * Purpose: The one place field widths and form column grids are defined, so every
 *          MetadataForm, TemplateForm and card lines up (ORCH-410 §4.4).
 * Architecture: Plain sx constants. Renderers set no width and fill their grid cell;
 *               containers set columns via fieldGridSx, never widths.
 * Dependencies: none
 * Author: Development Team
 * Created: 2026-10-17
 */

/** Width in px of every peer field. */
export const FIELD_WIDTH = 320;
/** Gap between field columns, in theme spacing units (24 px). */
export const FIELD_COLUMN_GAP = 3;
/** Gap between field rows, in theme spacing units (16 px). */
export const FIELD_ROW_GAP = 2;

/** sx for a grid of `columns` field columns; collapses to one below md. */
export const fieldGridSx = (columns: number) => ({
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: `repeat(${columns}, minmax(0, ${FIELD_WIDTH}px))` },
  columnGap: FIELD_COLUMN_GAP,
  rowGap: FIELD_ROW_GAP,
  justifyContent: 'start',
  alignItems: 'start',
});

/** sx for a field that spans every column of its grid (multiline text, files). */
export const fieldSpanAllSx = { gridColumn: '1 / -1' };

/** True for fields that genuinely need room and so span the grid: multiline text and files. */
export const spansAllColumns = (fieldDefinition: {
  datatype?: string;
  is_multiline?: boolean | null;
}): boolean => fieldDefinition.is_multiline === true || fieldDefinition.datatype === 'file';
